import {Stack} from '@primer/react'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import styles from './Header.module.css'

type HeaderProps = {
  children?: ReactNode
  className?: string
}

export default function Header({children, className}: HeaderProps) {
  return (
    <Stack justify={'space-between'} direction={'horizontal'} className={clsx(styles.container, className)}>
      {children}
    </Stack>
  )
}
